// extracted by mini-css-extract-plugin
export var frame = "modal-modules--frame--36whO";
export var layer = "modal-modules--layer--1JZGD";
export var modal = "modal-modules--modal--E0z0B";
export var close = "modal-modules--close--2iGDx";
export var footer = "modal-modules--footer--coJo3";